<template>
  <div>
    <v-container fluid>
      <div class="text-xs-right">
        <v-btn outline color="primary" :loading="loading" @click="exportFeedback">
          <em class="fas fa-file-export mr-1" />
          {{ $t('export') }}
        </v-btn>
      </div>
      <date-filter
        v-model="selectedDate"
        @changeDate="onDateChanged"
        :default-filter="'today'"
      ></date-filter>
    </v-container>
    <v-container>
      <v-data-table
        :rows-per-page-items="[25, 40, 50, 100]"
        :loading="loading"
        :headers="headers"
        :items="items"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left">
              {{ props.item.timestamp | dateFormat('DD/MM/YYYY HH:mm') }}
            </td>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.details }}</td>
            <td
              class="text-xs-left"
              style="white-space: nowrap; padding-top: 9px; padding-bottom: 9px"
            >
              บริการ {{ props.item.service }}
              <br />
              ความเร็ว {{ props.item.speed }}
              <br />
              คุณภาพ {{ props.item.quality }}
            </td>
            <td class="text-xs-left">{{ props.item.adminname }}</td>
            <td class="text-xs-center" style="white-space: nowrap">
              <div v-if="props.item.qa == null">
                <v-btn
                  depressed
                  :disabled="loadingBtn == props.item.id"
                  :loading="loadingBtn == props.item.id"
                  @click="qaUpdate(props.item, true)"
                  color="#55d85b"
                  small
                  style="color: white; width: 3.5em; min-width: 0"
                >
                  <em class="fas fa-check" />
                </v-btn>
                <v-btn
                  depressed
                  :disabled="loadingBtn == props.item.id"
                  :loading="loadingBtn == props.item.id"
                  @click="qaUpdate(props.item, false)"
                  color="#ff7166"
                  small
                  style="color: white; width: 3.5em; min-width: 0"
                >
                  <em class="fas fa-times" />
                </v-btn>
              </div>
              <div v-else>
                <div
                  v-if="props.item.qa"
                  @click="props.item.qa = null"
                  style="color: #55d85b; font-weight: 600; cursor: pointer"
                >
                  ผ่าน
                  <em style="color: grey" class="fas fa-pencil-alt" />
                </div>
                <div
                  v-else
                  @click="props.item.qa = null"
                  style="color: #ff7166; font-weight: 600; cursor: pointer"
                >
                  ไม่ผ่าน
                  <em style="color: grey" class="fas fa-pencil-alt" />
                </div>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import DateFilter from './DateFilter.vue'
import moment from 'moment'
import api from '@/api'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'

export default {
  components: {
    DateFilter
  },
  data() {
    return {
      data: '',
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },

      headers: [
        { text: 'เวลา', value: 'timestamp', align: 'center' },
        { text: 'ชื่อ', value: 'name' },
        { text: 'Feedback ลูกค้า', value: 'details' },
        { text: 'คะแนน', value: 'quality' },
        { text: 'ชื่อแอดมินที่รับผิดชอบ', value: 'adminname' },
        { text: 'QA', value: 'qa', align: 'center', sortable: false }
      ],
      items: [],
      loading: true,
      loadingBtn: ''
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getastonqacustomerservice()
  },
  methods: {
    exportFeedback() {
      var json = this.items.map((el) => {
        return {
          เวลา: el.timestamp,
          ชื่อ: el.name,
          'Feedback ลูกค้า': el.details,
          คะแนน: `คุณภาพ:${el.quality}, บริการ:${el.service}, ความเร็ว:${el.speed}`,
          ชื่อแอดมินที่รับผิดชอบ: el.adminname,
          QA: el.qa
        }
      })

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'aston-feedback-dashboard.xlsx')
    },
    name() {},
    getastonqacustomerservice() {
      this.loading = true
      api.getastonqacustomerservice(
        {
          datefrom: this.selectedDate.start,
          dateto: this.selectedDate.end,
          pageid: this.selectedBot.pageid
        },
        (error, response) => {
          this.items = response.data
          this.loading = false
        }
      )
    },
    onDateChanged() {
      this.getastonqacustomerservice()
    },
    qaUpdate(item, qa) {
      this.loadingBtn = item.id
      api.putastonqacustomerservice(
        { id: item.id, userid: item.userid, timestamp: item.timestamp, qa },
        (err, response) => {
          if (response.responsecode == 200) {
            item.qa = qa
            this.loadingBtn = ''
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/AstonDashboardFeedback.vue